import {Component, Input, OnInit} from '@angular/core';
import {FormArray, UntypedFormBuilder, FormGroup} from '@angular/forms';
import {DashboardService} from 'src/app/dashboard/dashboard.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-subjective-param',
    templateUrl: './subjective-param.component.html',
    styleUrls: ['./subjective-param.component.css'],
    standalone: false
})

export class SubjectiveParamComponent implements OnInit {

  constructor(
    private dashboardService: DashboardService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService) {
  }

  ngOnInit(): void {
  }


}
